module.exports = __webpack_public_path__ + "static/media/02.9cf73b38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Infographics/slides/02.jpg
// module id = 977
// module chunks = 0